import React, { useState } from 'react';
import img5 from '../assets/imagen_5.jpeg';
import img6 from '../assets/imagen_6.jpeg';
import img7 from '../assets/imagen_7.jpeg';
import img8 from '../assets/imagen_8.jpeg';
import img9 from '../assets/imagen_9.jpeg';
import img10 from '../assets/imagen_10.jpeg';
import img11 from '../assets/imagen_11.jpeg';
import img12 from '../assets/imagen_12.jpeg';
import img13 from '../assets/imagen_13.jpeg';
import img14 from '../assets/imagen_14.jpeg';

export default function Gallery({ images }) {
  const galleryImages = images || [img5, img6, img7, img8, img9, img10, img11, img12, img13, img14];
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {galleryImages.map((src, i) => (
          <button
            key={i}
            onClick={() => setOpenIndex(i)}
            className="overflow-hidden rounded-lg bg-gray-100 focus:outline-none hover:scale-105 transform transition"
            aria-label={`Abrir imagen ${i + 1}`}
          >
            <img src={src} alt={`Entrega ${i + 1}`} className="w-full h-36 object-cover" />
          </button>
        ))}
      </div>

      {openIndex !== null && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-6">
          <div className="absolute inset-0 bg-black/60" onClick={() => setOpenIndex(null)} />
          <div className="relative max-w-4xl w-full">
            <button
              onClick={() => setOpenIndex(null)}
              className="absolute top-3 right-3 z-10 bg-white/90 rounded-full p-2 hover:bg-white"
              aria-label="Cerrar galería"
            >
              <svg className="w-6 h-6 text-gray-800" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            <img src={galleryImages[openIndex]} alt={`Detalle ${openIndex + 1}`} className="w-full h-[70vh] object-contain bg-white rounded-lg shadow-xl" />

            <div className="absolute left-3 top-1/2 -translate-y-1/2">
              <button
                onClick={() => setOpenIndex((s) => (s === 0 ? galleryImages.length - 1 : s - 1))}
                className="bg-white/90 rounded-full p-2 hover:bg-white"
                aria-label="Anterior"
              >
                <svg className="w-6 h-6 text-gray-800" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M15 18l-6-6 6-6" />
                </svg>
              </button>
            </div>

            <div className="absolute right-3 top-1/2 -translate-y-1/2">
              <button
                onClick={() => setOpenIndex((s) => (s === galleryImages.length - 1 ? 0 : s + 1))}
                className="bg-white/90 rounded-full p-2 hover:bg-white"
                aria-label="Siguiente"
              >
                <svg className="w-6 h-6 text-gray-800" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 18l6-6-6-6" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
